export default __webpack_public_path__ + "7606239.png";